import { AfterViewInit, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { CustomerService } from 'src/app/services/customer.service';
import { GeoService } from 'src/app/services/geo.service';
import { ProductService } from 'src/app/services/products.service';
import { RateBandsService } from 'src/app/services/ratebands.service';
import { ChargesService } from 'src/app/services/system-config/charges/charges.service';
import { TATService } from 'src/app/services/system-config/tat/tat.service';
import { VendorService } from 'src/app/services/vendor.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-tatperiod',
    templateUrl: './tatperiod.component.html',
    styleUrls: ['./tatperiod.component.scss']
})
export class TATPeriodComponent implements AfterViewInit{
    @Input() showPeriodModal: any;
    @Input() periodData: any;
    @Input() tatTypes: any[];
    @Input() selectedSCId: any[];
    periodForm: FormGroup;
    isModelSubmitted = false;
    Id: number;
    vendorList: any;
    customerList: any;
    showContract = false;
    showCustomer = false;
    
    contractTypeList: any[] = [{ id: 1, name: 'Customer' }];
    useEnterKey: any;
    constructor(
        private formBuilder: FormBuilder,
        private tatService: TATService,
        private ngxLoaderService: NgxUiLoaderService,
        private customerService: CustomerService,
        public activeModal: NgbActiveModal,
        private utilities: Utilities,
        private appCoreService: AppCoreService

    ) { }

   async ngOnInit() {
        this.tatTypes = this.tatTypes.map(item => ({
            id: item.id,
            name: item.tattype 
          }));
        
        this.periodForm = this.formBuilder.group({
            ddlTATType: [null],
            ddlContractType: [null],
            txtFromDate: [this.utilities.FormatDateWithTime().dateString],
            txtToDate: [null, Validators.required],
            ddlCustomer: [null],

        });
       
        this.periodForm.get('ddlTATType').disable();
        this.periodForm.get('txtFromDate').disable();
        await this.getAllCustomers();
        this.bindFields(this.periodData);

        // const userData = this.appCoreService.GetUserData();
        // this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.periodForm) : null;
    }

    bindFields(cell: any) {
        if (cell) {
            this.Id = cell.id;
            let tatTypeId = this.tatTypes.find(x => x.name === cell.tattype)?.id;
            this.periodForm.get('ddlTATType').setValue(tatTypeId);
            this.periodForm.get('txtFromDate').setValue(this.utilities.FormatDateWithTime(0,cell.fromdate).dateString);
            this.periodForm.get('txtToDate').setValue(this.utilities.FormatDateWithTime(0,cell.todate).dateString);
            this.showCustomer = false;
            if (cell.tattype === 'Contract') {
                this.showContract = true;
                this.showCustomer = true;
                this.periodForm.get('ddlContractType').setValue(this.contractTypeList.find(x=>x.name === cell?.tatcontracttype).id);
                this.periodForm.get('ddlCustomer').setValue(cell?.customerid);
                this.periodForm.controls.ddlContractType.setValidators([Validators.required]);
                this.periodForm.controls.ddlCustomer.setValidators([Validators.required]);

            }
            this.periodForm.controls.ddlContractType.updateValueAndValidity();
            this.periodForm.controls.ddlCustomer.updateValueAndValidity();
        }
    }

    updatePeriod() {
        if (this.periodForm.valid) {
            const periodObj = {
                id: this.Id,
                fromdate: this.periodForm.controls.txtFromDate.value,
                todate: this.periodForm.controls.txtToDate.value,
                customerid: this.periodForm.controls.ddlCustomer.value,
            }
            this.ngxLoaderService.start();
            this.tatService.UpdateTAT(periodObj).subscribe(res => {
                try {
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        this.activeModal.close('Save Click');
                        this.appCoreService.showMessage('Record saved successfully')
                    }
                } catch (error) {
                    this.ngxLoaderService.stop();
                }
            });
        }
    }

     async getAllCustomers(){
        this.customerService.GetAll({scid: this.appCoreService.GetUserData().selectedServiceCenter}).subscribe((res) => {
            if (res && res.success) {
                this.customerList = res.data;
            }
        })
    }
}
